import React from 'react'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'

import AdminMediaModal from './AdminMediaModal'
import { AdminVideoModalStyle } from '../styles'
import { deleteVideo, updateVideo } from '../../reducers/videosReducer'

const config = {
    Icon: PlayArrowIcon,
    style: AdminVideoModalStyle,
    subKey: 'sub_videos',
    idPrefix: 'video',
    formLabel: 'Video details',
    rowsNoun: 'playlist',
    rowsHeading: 'Playlist',
    rowLabel: 'Video',
    update: updateVideo,
    remove: deleteVideo,
}

const AdminVideoModal = (props) => <AdminMediaModal config={config} {...props} />

export default AdminVideoModal
